import * as rpgDiceRoller from 'rpg-dice-roller'

const LABELS = {
	a: 'Acid',
	c: 'Cold',
	b: 'Bludgeoning',
	e: 'Electricity',
	f: 'Fire',
	p: 'Piercing',
	s: 'Slashing',
	so: 'Sonic',
}

const roller = new rpgDiceRoller.DiceRoller()

const state = {
	label: '',
	reroll: '',
	roll: {
		notation: '',
		output: '',
		rolls: [],
		total: '',
		type: '',
	},
	visible: false,
}

const getters = {
	total: (state) => {
		if (state.roll.total)
			return state.roll.total
		else
			return ''
	},
	dice: (state) => {
		if (state.roll.rolls[0])
			return state.roll.rolls[0].rolls
		else
			return []
	},
	parsed: (state) => {
		if (state.roll.notation)
			return rpgDiceRoller.Parser.parse(state.roll.notation).filter(function(element){
				return typeof(element.max) != 'undefined'
			})
		else
			return []
	},
}

const actions = {
	roll: ({ commit, state }, input) => {

		var [diceNotation, label] = input.split(' ', 2)

		if(label !== undefined && LABELS[label.toLowerCase()]){
			label = LABELS[label.toLowerCase()]
		}

		if(!state.reroll && label !== undefined){
			commit('set',{
				what: 'label',
				value: label,
			})
		}else if(!state.reroll && label === undefined){
			commit('set',{
				what: 'label',
				value: '',
			})
		}

		var thisRoll = roller.roll(diceNotation)

		commit('set', {
			what: 'roll',
			value: JSON.parse(JSON.stringify(thisRoll))
		})
		commit('set', {
			what: 'visible',
			value: true
		})
	},
	rerollOne: ({ commit, getters }, payload) => {
		commit('rerollOne',{
			sides: getters.parsed[payload.setIndex].max,
			...payload
		})
	},
	rerollAll: ({ commit, dispatch, state }) => {
		commit('set',{
			what: 'reroll',
			value: true
		})
		dispatch('roll', state.roll.notation );
		setTimeout( () => {
			commit('set',{
				what: 'reroll',
				value: false
			})
		}, 750)
	}
}

const mutations = {
	show (state)  {
		state.visible = true
	},
	hide (state) {
		state.visible = false
	},
	set (state, {what, value}) {
		state[what] = value
	},
	rerollOne (state, {setIndex, dieIndex, sides}) {
		state.reroll = true
		let modifiers = state.roll.rolls[setIndex].rolls[dieIndex].modifiers
		modifiers.push('rolling')

		let dieValue = state.roll.rolls[setIndex].rolls[dieIndex].value
		let setValue = state.roll.rolls[setIndex].value
		let oldValue = dieValue.valueOf();
		let newValue = roller.roll('1d'+sides).total

		state.roll.rolls[setIndex].rolls[dieIndex].value = dieValue - oldValue + newValue
		state.roll.rolls[setIndex].value = setValue - oldValue + newValue
		state.roll.total = state.roll.total - oldValue + newValue
		state.reroll = false
		modifiers.splice( modifiers.indexOf('rolling'), 1)
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}